import axios from "axios";
import PageCover from "../../adapters/page-cover-adapter";
import store from "./../index";

export default {
  namespaced: true,
  state: {
    covers: [],
  },
  getters: {
    getAbout(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 1;
      });
      return cover[0];
    },
    getServices(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 2;
      });
      return cover[0];
    },
    getPartners(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 3;
      });
      return cover[0];
    },
    getCareer(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 4;
      });
      return cover[0];
    },
    getContact(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 5;
      });
      return cover[0];
    },
    getFaq(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 6;
      });
      return cover[0];
    },
    getNurse(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 7;
      });
      return cover[0];
    },
    getNursePage(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 8;
      });
      return cover[0];
    },
    getLegal(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 9;
      });
      return cover[0];
    },
    getTermsOfServices(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 10;
      });
      return cover[0];
    },
    getImpressum(state) {
      let cover = state.covers.filter((x) => {
        return x.typeId == 11;
      });
      return cover[0];
    },
  },
  mutations: {
    setCovers(state, payload) {
      state.covers = payload;
    },
  },
  actions: {
    getCovers({ commit }) {
      store.commit("setLoader", true);
      return axios
        .get(`/home/about`)
        .then((response) => {
          const res = response.data.data.abouts;
          let lang = store.state.lang;
          commit(
            "setCovers",
            res.map((i) => {
              return new PageCover(i, lang);
            })
          );
          return true;
        })
        .catch(() => {
          return false;
        });
    },
  },
};
